<script>
import { mapGetters } from 'vuex'
import SystemUpdatePopup from '@/components/system-updates/SystemUpdatePopup.vue'

export default {
	name: 'Index',
	components: {
		SystemUpdatePopup,
	},
	data() {
		return {
			mobileStatus: false,
		}
	},
	computed: {
		...mapGetters(['_getUserObject']),
	},
	methods: {
		mobileActive(status) {
			this.mobileStatus = status
		},
	},
}
</script>

<template>
	<div class="wrapper">
		<v-header-admin @mobileActive="mobileActive"></v-header-admin>

		<router-view />

		<v-footer-admin></v-footer-admin>

		<SystemUpdatePopup />
	</div>
</template>
